import { replaceNewLinesWithBreaks } from '../utils/create-breaks'
import Image from 'next/image'
import styles from './hero-card.module.css'
import { TrackingEventTypes, useAnalytics } from '@cinch-nx/shared-analytics'

export interface HeroCardProps {
  heading: string
  subheading: string
  image: {
    filename: string
    alt?: string
  }
  cta?: {
    label: string
    url: string
  }[]
  imageLoader?: () => string
}

export const HeroCard = ({
  heading,
  subheading,
  image,
  cta,
  imageLoader,
}: HeroCardProps) => {
  const { trackEvent } = useAnalytics()

  const onHeroLinkClick = () => {
    trackEvent({
      eventName: `promo hero link`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: 'click',
          category: 'link',
          label: `Promo link click`,
          action: `Promo Link link click`,
        },
      },
    })
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>{replaceNewLinesWithBreaks(heading)}</h2>
      <h3 className={styles.subheading}>
        {replaceNewLinesWithBreaks(subheading)}
      </h3>
      {cta && cta[0] && (
        <a
          className={styles.link}
          aria-label={cta[0].label + ' button'}
          href={cta[0].url}
          target={'_blank'}
          rel="noreferrer"
          onClick={onHeroLinkClick}
        >
          {cta[0].label}
        </a>
      )}
      <div className={styles.imageContainer}>
        <Image
          src={image.filename}
          alt={image.alt ?? 'home hero offer representative image'}
          fill={true}
          style={{
            objectFit: 'contain',
          }}
          priority={true}
          loader={imageLoader}
        />
      </div>
    </div>
  )
}
